export default __webpack_public_path__ + "static/media/cloud.152768d7.svg";